import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';
import { useSportConfig } from '../../../hooks/useSportConfig';

const EventStarted = ({ eventName }) => {
    const { config } = useSportConfig();

    return (
        <Styled.Wrapper>
            <Styled.Text>
                The <Styled.Highlighted>{eventName}</Styled.Highlighted>{' '}
                {config.labels.eventNoun} has now{' '}
                <Styled.Highlighted>started</Styled.Highlighted>. Please check
                back later for the results.
            </Styled.Text>
        </Styled.Wrapper>
    );
};

EventStarted.propTypes = {
    eventName: PropTypes.string.isRequired
};

export default EventStarted;
